import React from 'react';
import './OrderFormStyles.css';

/**
 * Order confirmation component that displays a slide-up panel with order details
 */
const OrderFormConfirmation = ({ 
  orderDetails, 
  showConfirmation, 
  isConfirming,
  onCancel, 
  onConfirm 
}) => {
  if (!orderDetails) {
    return null;
  }

  const handleBackdropClick = (e) => {
    // Prevent propagation to avoid closing other modals
    e.stopPropagation();
    onCancel();
  };

  return (
    <>
      {/* Modal backdrop */}
      <div 
        className={`of-confirmation-backdrop ${showConfirmation ? 'visible' : ''}`}
        onClick={handleBackdropClick}
      ></div>

      {/* Confirmation modal */}
      <div className={`of-confirmation-modal ${showConfirmation ? 'visible' : ''}`}>
        <div className="of-confirmation-header">
          <span>{orderDetails.side === 'buy' ? 'Buy' : 'Sell'} Order Confirmation</span>
          <button 
            className="of-confirmation-close" 
            onClick={onCancel}
            aria-label="Close"
          >×</button>
        </div>
        
        <div className="of-confirmation-content">
          <div className="of-confirmation-item">
            <span className="of-confirmation-label">Market</span>
            <span className="of-confirmation-value">{orderDetails.marketName}</span>
          </div>
          
          <div className="of-confirmation-item">
            <span className="of-confirmation-label">Action</span>
            <span className={`of-confirmation-value of-${orderDetails.side}`}>
              {orderDetails.side === 'buy' ? 'Buy' : 'Sell'}
            </span>
          </div>
          
          <div className="of-confirmation-item">
            <span className="of-confirmation-label">Type</span>
            <span className="of-confirmation-value">
              {orderDetails.orderType === 'market' ? 'Market' : 'Limit'}
            </span>
          </div>
          
          <div className="of-confirmation-item">
            <span className="of-confirmation-label">Amount</span>
            <span className="of-confirmation-value">{orderDetails.amount}</span>
          </div>
          
          <div className="of-confirmation-item">
            <span className="of-confirmation-label">Price</span>
            <span className="of-confirmation-value">{orderDetails.formattedPrice}</span>
          </div>
          
          <div className="of-confirmation-item">
            <span className="of-confirmation-label">Leverage</span>
            <span className="of-confirmation-value">{orderDetails.leverage}x</span>
          </div>
          
          {/* Display SL/TP if enabled */}
          {orderDetails.stopLossEnabled && orderDetails.stopLoss && (
            <div className="of-confirmation-item">
              <span className="of-confirmation-label">Stop Loss</span>
              <span className="of-confirmation-value of-loss">{orderDetails.stopLoss}</span>
            </div>
          )}
          
          {orderDetails.takeProfitEnabled && orderDetails.takeProfit && (
            <div className="of-confirmation-item">
              <span className="of-confirmation-label">Take Profit</span>
              <span className="of-confirmation-value of-profit">{orderDetails.takeProfit}</span>
            </div>
          )}
          
          <div className="of-confirmation-disclaimer">
            By confirming this order, you agree to the trading terms and conditions.
          </div>
        </div>
        
        <div className="of-confirmation-buttons">
          <button 
            className="of-button of-cancel-button" 
            onClick={onCancel}
            disabled={isConfirming}
          >
            CANCEL
          </button>
          <button 
            className={`of-button of-confirm-button of-${orderDetails.side}`} 
            onClick={onConfirm}
            disabled={isConfirming}
          >
            {isConfirming ? 'CONFIRMING...' : 'CONFIRM'}
          </button>
        </div>
      </div>
    </>
  );
};

export default OrderFormConfirmation; 